import {onFind} from "@elements/init-modules-in-scope";
import {removeClass, addClass, hasClass, findIn, findAllIn, closest, on} from '@elements/dom-utils';
import {getPrefixedDataSet} from "@elements/data-set-utils";
import Collapse from 'bootstrap/js/dist/collapse';


export function init () {
    onFind('.js-hotspot-map', baseElement => {
        let hotspots = findAllIn('.js-hotspot-map__hotspot', baseElement);
        let teasers = findAllIn('.js-hotspot-map__teaser', baseElement);
        let activeItem = new URLSearchParams(window.location.search).get('activeitem');

        if (activeItem) {
            teasers.map(teaser => {
                let dataSetTeaser = getPrefixedDataSet('hotspot-map', teaser);

                hotspots.map(hotspot => {
                    let dataSetHotspot = getPrefixedDataSet('hotspot-map', hotspot);

                    if (dataSetHotspot.id === activeItem) {
                        addClass('is-active', hotspot);

                        let hotspotTooltip = findIn('.js-hotspot-map__hotspot-name', hotspot);
                        hotspotTooltip.innerHTML = dataSetTeaser.description;
                    }

                    if (dataSetTeaser.id === activeItem) {
                        scrollIntoViewWithOffset(teaser, 175, window);
                        addClass('is-active', teaser);
                        let collapse = Collapse.getOrCreateInstance(findIn('.js-hotspot-teaser__body--sm', teaser));
                        collapse.show();
                    }
                });
            });
        }

        teasers.map(teaser => {
            let dataSetTeaser = getPrefixedDataSet('hotspot-map', teaser);


            on('mouseover', (e) => {
                hotspots.map(hotspot => {
                    let dataSetHotspot = getPrefixedDataSet('hotspot-map', hotspot);

                    if(dataSetHotspot.id === dataSetTeaser.id ) {
                        addClass('is-active', hotspot);

                        let hotspotTooltip = findIn('.js-hotspot-map__hotspot-name', hotspot);
                        hotspotTooltip.innerHTML = dataSetTeaser.description;
                    }
                });
            }, teaser);

            on('mouseleave', (e) => {
                hotspots.map(hotspot => {
                    let dataSetHotspot = getPrefixedDataSet('hotspot-map', hotspot);

                    if(dataSetHotspot.id === dataSetTeaser.id ) {
                        removeClass('is-active', hotspot);
                    }
                });
            }, teaser);
        });

        hotspots.map(hotspot => {
            let dataSetTeaser = getPrefixedDataSet('hotspot-map', hotspot);

            on('mouseover', (e) => {
                teasers.map(teasers => {
                    let dataSetHotspot = getPrefixedDataSet('hotspot-map', teasers);

                    if(dataSetHotspot.id === dataSetTeaser.id ) {
                        // addClass('is-active', teasers);

                        let hotspotTooltip = findIn('.js-hotspot-map__hotspot-name', hotspot);
                        hotspotTooltip.innerHTML = dataSetHotspot.description;
                    }
                });
            }, hotspot);

            on('mouseleave', (e) => {
                teasers.map(teaser => {
                    let dataSetHotspot = getPrefixedDataSet('hotspot-map', teaser);

                    if(dataSetHotspot.id === dataSetTeaser.id ) {
                        // removeClass('is-active', teaser);
                    }
                });
            }, hotspot);

            on('click', (e) => {
                hotspots.map(element => {
                    removeClass('is-active', element);
                })

                addClass('is-active', hotspot);

                let dataSetHotspot = getPrefixedDataSet('hotspot-map', hotspot);
                window.history.replaceState(null, '', `?activeitem=${dataSetHotspot.id}`);

                teasers.map( teasers => {
                    removeClass('is-active', teasers);
                    let dataSetHotspot = getPrefixedDataSet('hotspot-map', teasers);

                    if(dataSetHotspot.id === dataSetTeaser.id ) {
                        scrollIntoViewWithOffset(teasers, 175, window);
                        addClass('is-active', teasers);
                        let collapse = Collapse.getOrCreateInstance(findIn('.js-hotspot-teaser__body--sm', teasers));
                        collapse.show();
                    }
                });

            }, hotspot);
        });
    });
}

const scrollIntoViewWithOffset = (element, offset, container) => {
    container.scrollTo({
        behavior: 'smooth',
        top:
            element.getBoundingClientRect().top -
            document.body.getBoundingClientRect().top -
            offset,
    })
}